package com.artvending.warden

external val navigator: Navigator


external interface Navigator {
	val geolocation: Geolocation
}


external interface PositionOptions {
	var enableHighAccuracy: Boolean?
	var timeout: Int?
	var maximumAge: Int?
}


external interface Geolocation {
	fun getCurrentPosition(successCallback: (position: Position) -> Unit, errorCallback: (error: dynamic) -> Unit, options: PositionOptions)
}


external interface Position {
	val coords: Coordinates
}


external interface Coordinates {
	val latitude: Double
	val longitude: Double
}


class JsGeolocationManager : GeolocationManager {
	override suspend fun getGeolocation(): GeolocationResult? = action<GeolocationResult> { release ->
		try {
			val options: PositionOptions = js("{}")
			options.enableHighAccuracy = true
			options.timeout = 5000
			options.maximumAge = 0
			
			navigator.geolocation.let { geolocation ->
				try {
					geolocation.getCurrentPosition(
						{ position ->
							release(GeolocationResult(Point(position.coords.latitude, position.coords.longitude)))
						},
						{ error ->
							release(GeolocationResult(null, "Geolocation error ${error.code}. ${error.message}"))
						},
						options
					)
				} catch (e: Throwable) {
					showError(e.toString())
				}
			}
		} catch (e: Throwable) {
			showError(e.toString())
		}
	}
}